import React from 'react';
import {
  getTotalBudgetString, useApiClient, useFetch,
} from '@marageti/z4-lib';
import { SalesRecording, TripMatch } from '@marageti/z4-sdk/lib/travel';
import {
  Box,
  Typography,
  Divider,
  styled,
  Skeleton,
  CardHeader,
  Card,
  CardContent,
  Stack,
} from '@mui/material';
import { salesRecordingTypeLabel } from '../../utils/sales';

const SaleRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const SkeletonRow = () => (
  <SaleRow>
    <Skeleton variant="rectangular" height={20} width={80} />
    <Skeleton variant="rectangular" height={20} width={50} />
  </SaleRow>
);

const TripMatchSalesCard = ({ tripMatch }: { tripMatch: TripMatch }) => {
  const apiClient = useApiClient();

  const { data: salesRecordings, isLoading } = useFetch<SalesRecording[]>(apiClient.tripMatchesClient.getTripMatchSalesRecordings, [tripMatch.id], !!tripMatch.id);

  const calculatedTotalSales = salesRecordings?.reduce((sum, sale) => ({
    ...sale.price,
    amount: sum.amount + sale.price.amount,
    amountUSD: sum.amountUSD + sale.price.amountUSD,
  }), { ...salesRecordings?.[0]?.price, amount: 0, amountUSD: 0 });

  return (
    <Card>
      <CardHeader title="Sales" />

      <CardContent>
        <Stack spacing={2}>
          {isLoading ? (
            <SkeletonRow />
          ) : (
            salesRecordings?.map((sale: SalesRecording) => (
              <SaleRow key={sale.referenceId}>
                <Typography>
                  {salesRecordingTypeLabel[sale.salesRecordingType]}
                </Typography>
                <Typography textAlign="right">
                  {getTotalBudgetString(sale.price.amount, 2, 2, sale.price.currencyCode)}
                </Typography>
              </SaleRow>
            ))
          )}
        </Stack>

        <Divider sx={{ marginTop: 2, marginBottom: 2 }} />

        {isLoading ? (
          <SkeletonRow />
        ) : (
          <SaleRow>
            <Typography fontWeight="bold">
              Total Trip Price
            </Typography>
            <Typography fontWeight="bold" textAlign="right">
              {calculatedTotalSales && getTotalBudgetString(calculatedTotalSales.amount, 2, 2, calculatedTotalSales.currencyCode)}
            </Typography>
          </SaleRow>
        )}
      </CardContent>
    </Card>
  );
};

export default TripMatchSalesCard;
